import React from 'react';
import { GraduationCap, Briefcase, Award, Target } from 'lucide-react';
import { SEOSchema } from '../components/SEOSchema';
import { useLanguage } from '../contexts/LanguageContext';
export function ManagementPage() {
  const {
    t
  } = useLanguage();
  return <div className="pt-20 min-h-screen bg-white" data-id="element-817">
      <SEOSchema type="about" title={t('Manajemen | PT Graha Riau Gemilang', 'Management | PT Graha Riau Gemilang')} description={t('Mengenal Musdalil Amri, S.Si., M.M., Direktur & Pendiri PT Graha Riau Gemilang. Pengalaman 20+ tahun dalam pengembangan properti dengan filosofi MSDL: Menang, Semangat, Dinamis, Lugas.', 'Meet Musdalil Amri, S.Si., M.M., Founder & Managing Director of PT Graha Riau Gemilang. 20+ years of experience in real estate development with MSDL philosophy: Winning, Passion, Dynamic, Straightforward.')} breadcrumbs={[{
      name: t('Beranda', 'Home'),
      url: 'https://grahariaugemilang.com/'
    }, {
      name: t('Manajemen', 'Management'),
      url: 'https://grahariaugemilang.com/manajemen'
    }]} data-id="element-818" />

      {/* Header */}
      <div className="bg-gray-900 text-white py-20" data-id="element-819">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-820">
          <h1 className="text-4xl font-bold mb-4" data-id="element-821">
            {t('Manajemen', 'Management')}
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-822">
            {t('Dipimpin oleh profesional berpengalaman dengan visi yang kuat.', 'Led by experienced professionals with a strong vision.')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-823">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-824">
          <div className="flex flex-col lg:flex-row" data-id="element-825">
            {/* Photo Section */}
            <div className="lg:w-1/3 bg-gray-100 relative min-h-[500px] lg:min-h-[400px]" data-id="element-826">
              <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/htXauDrU3msoiwRWMoZS5B/OWNER.jpg')] bg-cover bg-center lg:bg-top" data-id="element-827"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent lg:hidden" data-id="element-828" />
              <div className="absolute bottom-0 left-0 p-8 text-white lg:hidden" data-id="element-829">
                <h2 className="text-2xl font-bold" data-id="element-830">
                  Musdalil Amri, S.Si., M.M.
                </h2>
                <p className="text-gray-200" data-id="element-831">
                  {t('Direktur & Pendiri', 'Founder & Managing Director')}
                </p>
              </div>
            </div>

            {/* Content Section */}
            <div className="lg:w-2/3 p-8 md:p-12" data-id="element-832">
              <div className="hidden lg:block mb-8" data-id="element-833">
                <div className="flex items-center justify-between mb-4" data-id="element-834">
                  <div className="flex-1" data-id="element-835">
                    <h2 className="text-3xl font-bold text-gray-900" data-id="element-836">
                      Musdalil Amri, S.Si., M.M.
                    </h2>
                    <p className="text-xl text-[#C4161C] font-medium" data-id="element-837">
                      {t('Direktur & Pendiri', 'Founder & Managing Director')}
                    </p>
                    <p className="text-sm text-gray-500 mt-2" data-id="element-838">
                      {t('PT Graha Riau Gemilang • Sejak 07 April 2005', 'PT Graha Riau Gemilang • Since April 7, 2005')}
                    </p>
                  </div>
                  <div className="ml-6 flex-shrink-0" data-id="element-839">
                    <img src="https://cdn.magicpatterns.com/uploads/h6dXqg8YCm9ajiPZBYs979/MSDL.jpg" alt="MSDL Logo" className="w-24 h-24 object-contain" data-id="element-840" />
                  </div>
                </div>
              </div>

              {/* MSDL Philosophy */}
              <div className="bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-[#C4161C] rounded-lg p-6 mb-8" data-id="element-841">
                <div className="flex items-start space-x-3 mb-4" data-id="element-842">
                  <Target className="w-6 h-6 text-[#C4161C] flex-shrink-0 mt-1" data-id="element-843" />
                  <div data-id="element-844">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-845">
                      {t('MSDL: Kunci Entrepreneurship', 'MSDL: The Key to Entrepreneurship')}
                    </h3>
                    <p className="text-sm font-semibold text-[#C4161C] mb-3" data-id="element-846">
                      {t('MENANG • SEMANGAT • DINAMIS • LUGAS', 'WINNING • PASSION • DYNAMIC • STRAIGHTFORWARD')}
                    </p>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed" data-id="element-847">
                  {t('Sebagai Direktur dan Pendiri PT. Graha Riau Gemilang, Musdalil Amri memimpin perusahaan dengan filosofi MSDL — empat nilai fundamental yang menjadi kunci kesuksesan entrepreneurship-nya. Menang mencerminkan determinasi untuk meraih target dan memberikan hasil terbaik. Semangat adalah energi dan dedikasi dalam setiap proyek. Dinamis menunjukkan adaptabilitas terhadap perubahan pasar dan inovasi berkelanjutan. Lugas adalah komitmen pada transparansi dan integritas bisnis. Kombinasi nilai-nilai ini telah menghasilkan puluhan proyek strategis dengan ribuan unit properti berkualitas tinggi selama lebih dari 20 tahun.', 'As the Founder and Managing Director of PT. Graha Riau Gemilang, Musdalil Amri leads the company with the MSDL philosophy — four fundamental values that are the key to his entrepreneurial success. Winning reflects the determination to achieve targets and deliver the best results. Passion is the energy and dedication in every project. Dynamic demonstrates adaptability to market changes and continuous innovation. Straightforward is a commitment to transparency and business integrity. This combination of values has resulted in dozens of strategic projects with thousands of high-quality property units over more than 20 years.')}
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-848">
                {/* Education & Career Journey */}
                <div data-id="element-849">
                  <div className="flex items-center space-x-3 mb-4" data-id="element-850">
                    <div className="bg-red-50 p-2 rounded text-[#C4161C]" data-id="element-851">
                      <GraduationCap className="w-6 h-6" data-id="element-852" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-853">
                      {t('Pendidikan & Perjalanan Karir', 'Education & Career Journey')}
                    </h3>
                  </div>
                  <ul className="space-y-4 border-l-2 border-gray-100 pl-4 ml-2" data-id="element-854">
                    <li className="relative" data-id="element-855">
                      <div className="absolute -left-[21px] top-1.5 w-3 h-3 rounded-full bg-gray-300" data-id="element-856"></div>
                      <span className="block text-sm text-gray-500" data-id="element-857">
                        1999–2000
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-858">
                        {t('Teknik Telekomunikasi – Politeknik Bandung', 'Telecommunication Engineering – Politeknik Bandung')}
                      </span>
                    </li>
                    <li className="relative" data-id="element-859">
                      <div className="absolute -left-[21px] top-1.5 w-3 h-3 rounded-full bg-gray-300" data-id="element-860"></div>
                      <span className="block text-sm text-gray-500" data-id="element-861">
                        2000–2002
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-862">
                        {t('Teknik Sipil – Universitas Parahyangan', 'Civil Engineering – Universitas Parahyangan')}
                      </span>
                    </li>
                    <li className="relative" data-id="element-863">
                      <div className="absolute -left-[21px] top-1.5 w-3 h-3 rounded-full bg-gray-300" data-id="element-864"></div>
                      <span className="block text-sm text-gray-500" data-id="element-865">
                        2001–2005
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-866">
                        {t('S1 Fisika – Institut Teknologi Bandung', 'Bachelor of Science in Physics – Institut Teknologi Bandung')}
                      </span>
                    </li>
                    <li className="relative" data-id="element-867">
                      <div className="absolute -left-[21px] top-1.5 w-3 h-3 rounded-full bg-[#C4161C]" data-id="element-868"></div>
                      <span className="block text-sm text-gray-500" data-id="element-869">
                        07 April 2005
                      </span>
                      <span className="font-medium text-[#C4161C]" data-id="element-870">
                        {t('Mendirikan PT. Graha Riau Gemilang', 'Founded PT. Graha Riau Gemilang')}
                      </span>
                    </li>
                    <li className="relative" data-id="element-871">
                      <div className="absolute -left-[21px] top-1.5 w-3 h-3 rounded-full bg-blue-600" data-id="element-872"></div>
                      <span className="block text-sm text-gray-500" data-id="element-873">2022</span>
                      <span className="font-medium text-gray-900" data-id="element-874">
                        {t('Alumni Pemantapan Nilai-Nilai Kebangsaan – LEMHANNAS RI', 'Alumni of National Values Consolidation Program – LEMHANNAS RI')}
                      </span>
                      <span className="block text-xs text-gray-500 mt-1" data-id="element-875">
                        {t('Lembaga Ketahanan Nasional Republik Indonesia', 'National Resilience Institute of the Republic of Indonesia')}
                      </span>
                    </li>
                    <li className="relative" data-id="element-876">
                      <div className="absolute -left-[21px] top-1.5 w-3 h-3 rounded-full bg-[#C4161C]" data-id="element-877"></div>
                      <span className="block text-sm text-gray-500" data-id="element-878">
                        2024–2025
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-879">
                        {t('S2 Magister Manajemen – Universitas Lancang Kuning', 'Master of Management – Universitas Lancang Kuning')}
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Organizational Leadership */}
                <div data-id="element-880">
                  <div className="flex items-center space-x-3 mb-4" data-id="element-881">
                    <div className="bg-red-50 p-2 rounded text-[#C4161C]" data-id="element-882">
                      <Briefcase className="w-6 h-6" data-id="element-883" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-884">
                      {t('Kepemimpinan & Kontribusi Organisasi', 'Leadership & Organizational Contributions')}
                    </h3>
                  </div>
                  <ul className="space-y-3" data-id="element-885">
                    <li className="bg-gray-50 p-4 rounded-lg border-l-4 border-green-500" data-id="element-886">
                      <span className="block text-sm text-green-600 font-semibold mb-1" data-id="element-887">
                        2021–2025
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-888">
                        {t('Ketua Futsal Pekanbaru', 'Chairman – Futsal Pekanbaru')}
                      </span>
                    </li>
                    <li className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#C4161C]" data-id="element-889">
                      <span className="block text-sm text-[#C4161C] font-semibold mb-1" data-id="element-890">
                        2024–2027
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-891">
                        {t('Sekjen IMA Chapter Pekanbaru', 'Secretary General – IMA Chapter Pekanbaru')}
                      </span>
                    </li>
                    <li className="bg-gray-50 p-4 rounded-lg border-l-4 border-blue-500" data-id="element-892">
                      <span className="block text-sm text-blue-600 font-semibold mb-1" data-id="element-893">
                        2025–2030
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-894">
                        {t('Pengurus Apindo Riau', 'Board Member – Apindo Riau')}
                      </span>
                    </li>
                    <li className="bg-gray-50 p-4 rounded-lg border-l-4 border-cyan-500" data-id="element-895">
                      <span className="block text-sm text-cyan-600 font-semibold mb-1" data-id="element-896">
                        2025–2029
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-897">
                        {t('Bendahara Akuatik Riau', 'Treasurer – Akuatik Riau')}
                      </span>
                    </li>
                    <li className="bg-gray-50 p-4 rounded-lg border-l-4 border-orange-500" data-id="element-898">
                      <span className="block text-sm text-orange-600 font-semibold mb-1" data-id="element-899">
                        2026–2030
                      </span>
                      <span className="font-medium text-gray-900" data-id="element-900">
                        {t('Bendahara Orado Riau', 'Treasurer – Orado Riau')}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Closing Statement */}
              <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-901">
                <p className="text-gray-600 leading-relaxed italic" data-id="element-902">
                  {t('Dedikasi beliau dalam berbagai organisasi menunjukkan komitmen holistik terhadap kemajuan ekonomi, olahraga, dan komunitas lokal di Riau.', 'His dedication across various organizations demonstrates a holistic commitment to economic progress, sports, and the local community in Riau.')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}